<div class="board-wrapper">
  @if (!freeBet) {
    <div class="card">
      <span>
        Selecciona el tipo de apuestas
      </span>
      <button class="toRight typeButton" (click)="selectBetType()">
        {{betType?.combinaciones > 1 ? 'Multiple' : 'Simple'}}
      </button>
    </div>
  }
  <!-- <div class="bets"> -->
  @if (betType == undefined || betType?.combinaciones == 1) {
    <div class="bets">
      @if (!freeBet) {
        <div class="bet-controls">
          <span>Número de apuestas</span>
          <button class="bet-toggle" (click)="toggleBetsList()">
            <img class="icon" [class.rotated]="showBetsList" src="assets/images/icons/down.svg">
          </button>
          <button class="btn-ctrl toRight" [disabled]="gameModel.bets.length <= 1" (click)="changeBetNumberWithDelay(-1)">-</button>
          <span class="bet-number">{{gameModel.bets.length}}</span>
          <button class="btn-ctrl" (click)="changeBetNumberWithDelay(1)">+</button>
        </div>
      }
      @if (showBetsList) {
        <div class="bets-list">
          @for (bet of gameModel.bets.slice(0, gameModel.minBetsLimit); track bet; let i = $index) {
            <div class="bet"
              [class.selected]="i === gameModel.selectedBet" (click)="gameModel.setSelectedBet(i)">
              <span class="label">{{i+1}}.</span>
              @for (item of bet.auxNumbersChecked; track item) {
                <span class="number" [class.used]="gameModel.bets[i].numbersChecked.includes(item)">
                  {{item}}
                </span>
              }
              @if ((gameId !== 4 && bet.auxExtraChecked.length > 0) || (gameId === 4 && i === 0 && bet.auxExtraChecked.length > 0)) {
                <span class="number guion"
                >-</span>
              }
              @if (gameId !== 4 || (gameId === 4 && i === 0)) {
                @for (item of bet.auxExtraChecked; track item) {
                  <span class="number" [class.used]="gameModel.bets[i].extraChecked.includes(item)">
                    {{item}}
                  </span>
                }
              }
            </div>
          }
          @if (!showAll) {
            <div>
              @for (bet of gameModel.bets.slice(gameModel.minBetsLimit); track bet; let i = $index) {
                <div class="bet"
                  [class.selected]="(i + gameModel.minBetsLimit) === gameModel.selectedBet" (click)="gameModel.setSelectedBet(i + gameModel.minBetsLimit)">
                  <span class="label">{{i+1+gameModel.minBetsLimit}}.</span>
                  @for (item of bet.auxNumbersChecked; track item) {
                    <span class="number" [class.used]="gameModel.bets[i + gameModel.minBetsLimit].numbersChecked.includes(item)">
                      {{item}}
                    </span>
                  }
                  @if ((gameId !== 4 && bet.auxExtraChecked.length > 0)) {
                    <span class="number guion"
                    >-</span>
                  }
                  @if (gameId !== 4) {
                    @for (item of bet.auxExtraChecked; track item) {
                      <span class="number" [class.used]="gameModel.bets[i + gameModel.minBetsLimit].extraChecked.includes(item)">
                        {{item}}
                      </span>
                    }
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      @if (gameModel.bets?.length > gameModel.minBetsLimit) {
        <button class="visibility-button" (click)="showAll = !showAll">{{ !showAll ? 'Ver menos' : 'Ver más' }}</button>
      }
    </div>
  }
  <div class="card">
    <img src="assets/images/icons/plays/{{gameId}}.png" class="game-img">
    <span class="game-name">{{gameModel.name}}</span>
    <button class="button toRight" (click)="gameModel.cleanBet()">
      <img src="assets/images/icons/play-detail/ic_delete_bin.svg">
    </button>
    <button class="button primary" (click)="gameModel.randomNumberSelection()">
      <img src="assets/images/icons/games/button/Cube 6.svg">
    </button>
  </div>

  <div class="board-wrapper" [class.mobile]="device === devices.MOBILE" [class.desktop]="device === devices.DESKTOP">
    <div class="board">
      <div class="grid-label">A{{gameModel.selectedBet + 1}}</div>
      @for (item of gameModel.board; track item) {
        <div class="grid-item game-{{gameId}}"
          [class.selected]="gameModel?.bets[gameModel?.selectedBet]?.numbersChecked?.includes(item)"
          (click)="gameModel.toggleNumberSelection(item)">
          {{item}}
        </div>
      }
    </div>
    @if (gameModel.boardExtra.length > 0) {
      <div class="board extra">
        @for (item of gameModel.boardExtra; track item) {
          <div class="grid-item game-{{gameId}}"
            [class.selected]="gameModel?.bets[gameModel?.selectedBet]?.extraChecked?.includes(item)"
            (click)="gameModel.toggleNumberSelection(item, 'extra')">
            {{item}}
          </div>
        }
      </div>
    }
  </div>
</div>